export const UNIVERSIDADE_CORPORATIVA_CATEGORIA_ID = "UCpv1l8ibs40GfO6A6s2";
